export default __webpack_public_path__ + "bf35b4d04930ca78799d15200b052e81.js";